import React from 'react';
import Form from "react-bootstrap/Form";

const RegistrationInfoForm = ({isAdmin, fields, handleFieldChange,
                               gender, handleSetGender, genderMessage,
                               destination, handleSetDestination, destinationMessage,
                               messages, page, isEdit}) => {
    const docheck = () => {
        console.log("docheck : " + fields.gender);
//        console.log(e.target.value);
        const b = "1" == fields.gender;
        console.log (b ? 'Yes' : 'NO');
        return b;
    }
  return (
    <>
      <h2>登録情報</h2>
      <dl>
        <dt>氏名<span className="red">*</span></dt>
        <dd>
          <Form.Group controlId="familyName" className="inlineFormControl" size="lg">
          <span className="inlineFdLabel">姓</span>
            <Form.Control
              type="text"
              name="familyName"
              value={fields.familyName}
              onChange={handleFieldChange}
            />
          </Form.Group>
          <Form.Group controlId="givenName" className="inlineFormControl" size="lg">
          <span className="inlineFdLabel">名</span>
            <Form.Control
              type="text"
              name="givenName"
              value={fields.givenName}
              onChange={handleFieldChange}
            />
          </Form.Group>
          <p>例：山田　太郎</p>
         <p id="familyNameMessage" className="errorMessages">{messages.familyName.n}</p>
         <p id="givenNameMessage" className="errorMessages">{messages.givenName.n}</p>
        </dd>
        <dt>氏名（フリガナ）<span className="red">*</span></dt>
        <dd>
          <Form.Group controlId="familyNameKana" className="inlineFormControl" size="lg">
          <span className="inlineFdLabel">セイ</span>
            <Form.Control
              type="text"
              name="familyNameKana"
              value={fields.familyNameKana}
              onChange={handleFieldChange}
            />
          </Form.Group>
          <Form.Group controlId="givenNameKana" className="inlineFormControl" size="lg">
          <span className="inlineFdLabel">メイ</span>
            <Form.Control
              type="text"
              name="givenNameKana"
              value={fields.givenNameKana}
              onChange={handleFieldChange}
            />
          </Form.Group>
          <p>例：ヤマダ　タロウ</p>
         <p id="familyNameKanaMessage" className="errorMessages">{messages.familyNameKana.n}</p>
         <p id="givenNameKanaMessage" className="errorMessages">{messages.givenNameKana.n}</p>
        </dd>

        <dt>性別<span className="red">*</span></dt>
        <dd>
          <Form.Group size="lg">
            <Form.Check
              inline
              id="gender"
              label="男"
              type="radio"
              name="gender"
              value="1"
              checked={ 1 == gender }
              onChange={ handleSetGender  }
            />
            <Form.Check
              inline
              label="女"
              type="radio"
              name="gender"
              value="2"
              checked={ 2 == gender }
              onChange={ handleSetGender  }
            />
          </Form.Group>
          <p id="genderMessage" className="errorMessages">{genderMessage}</p>
        </dd>

        <dt>生年月日<span className="red">*</span></dt>
        <dd>
          <Form.Group controlId="birthDate" size="lg">
            <Form.Control
              type="text"
              name="birthDate"
              value={fields.birthDate}
              onChange={handleFieldChange}
            />
          </Form.Group>
          <p>例：2021/01/01</p>
          <p id="birthDateMessage" className="errorMessages">{messages.birthDate.n}</p>
        </dd>

        <dt>送付先<span className="red">*</span></dt>
        <dd>
          <Form.Group size="lg">
            <Form.Check
              inline
              id="destination"
              label="現住所"
              type="radio"
              name="destination"
              value="1"
              checked={ 1 == destination }
              onChange={ handleSetDestination }
            />
            <Form.Check
              inline
              label="所属先"
              type="radio"
              name="destination"
              value="2"
              checked={ 2 == destination }
              onChange={ handleSetDestination }
            />
           { isAdmin ? <>
            <Form.Check
              inline
              label="不明"
              name="destination"
              type="radio"
              value="3"
              checked={ 3 == destination }
              onChange={ handleSetDestination }
            />
            <Form.Check
              inline
              label="休会中"
              name="destination"
              type="radio"
              value="4"
              checked={ 4 == destination }
              onChange={ handleSetDestination }
            />
            <Form.Check
              inline
              label="不要"
              name="destination"
              type="radio"
              value="5"
              checked={ 5 == destination }
              onChange={ handleSetDestination }
             /> </> : <></> }

          </Form.Group>
          <p id="destinationMessage" className="errorMessages">{destinationMessage}</p>
        </dd>

      </dl>
    </>
  );
}

export default RegistrationInfoForm;
